import type { IAgentTool } from '../../../../core/ai/agent/IAgentTool';
import { ApplyAutoLayoutCommand } from '../../../process/commands/ApplyAutoLayoutCommand';

export const layoutTool: IAgentTool = {
  name: 'flow_layout',
  description: 'Auto-layout the flowchart using the existing layout engine.',
  parameters: {
    type: 'object',
    properties: {
      strategy: { type: 'string', enum: ['left-to-right', 'top-to-bottom', 'hierarchical', 'compact'], default: 'left-to-right' },
    },
  },
  supportedDiagramTypes: ['flowchart'],
  tier: 'visual',
  category: 'layout',

  async execute(params: Record<string, unknown>) {
    const allowed = new Set(['left-to-right', 'top-to-bottom', 'hierarchical', 'compact']);
    const requested = typeof params.strategy === 'string' ? params.strategy : 'left-to-right';
    const strategy = (allowed.has(requested) ? requested : 'left-to-right') as 'left-to-right' | 'top-to-bottom' | 'hierarchical' | 'compact';
    const command = new ApplyAutoLayoutCommand({ options: { strategy, nodeSpacing: 80, rankSpacing: 100 } });
    return {
      success: true,
      summary: `Applied ${strategy} layout.`,
      createdResourceIds: [command.id],
      execution: { kind: 'command', command },
    };
  },
};
